const SERVICE = "market/customer";

const productsList = async (api, params) =>
  api.setMethod().get().setService(SERVICE).process("/catalogue", params);

const newProducts = async (api, params) =>
  api.setMethod().get().setService(SERVICE).process("/catalogue/new", params);

const particularProducts = async (api, uuid) =>
  api.setMethod().get().setService(SERVICE).process(`/catalogue/${uuid}`);

const storeDetails = async (api) =>
  api
    .setMethod()
    .get()
    .setService(SERVICE)
    .process("/catalogue/store/b2c-store-8m");
const storeProductsList = async (api, params) =>
  api
    .setMethod()
    .get()
    .setService(SERVICE)
    .process("/catalogue/store/b2c-store-8m/product", params);
module.exports = {
  productsList,
  newProducts,
  particularProducts,
  storeDetails,
  storeProductsList,
};
